export function checkSSOConfig(file) {
  if (file["extension"] !== "xml") return false;

  var fileName = file["filename"];
  if (fileName.includes("connector")) return false;

  var connectorFiles = [
    "azure",
    "adpworkforcenow",
    "bamboohr",
    "breathehr",
    "greenhouse",
    "icims",
    "namely",
    "peoplehr",
    "salesforce",
    "sapxml",
    "signify",
    "subscribehr",
    "successfactors",
    "ultipro",
    "workday"
  ];
  var isConnector = connectorFiles.some(function (connector) {
    return fileName.endsWith("_" + connector);
  });

  var internalFiles = [
    "userlist",
    "boxstyles",
    "charttemplates",
    "metadata",
    "querybuilder",
    "customconn",
    "dynamic_chart"
  ];

  return !(internalFiles.includes(fileName) || isConnector);
}
